import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { Capacitor } from '@capacitor/core';

// Firebase configuration - using hardcoded values to avoid env issues
// On iOS, Firebase will auto-detect GoogleService-Info.plist if no config is provided
const firebaseConfig = {
  apiKey: "AIzaSyBq1eloUDVA2XfSlLuUCOdDVqdEoDeYfl4",
  authDomain: "www.streakerbymx.com",
  projectId: "waka-running",
  storageBucket: "waka-running.firebasestorage.app",
  messagingSenderId: "194976321177",
  appId: Capacitor.getPlatform() === 'ios' 
    ? "1:194976321177:ios:27d09e4396e4f104fe3208" // iOS app ID from GoogleService-Info.plist
    : "1:194976321177:web:274296441dd5c1f8fe3208", // Web app ID
  measurementId: "G-K1P5PR1XSV"
};

// Initialize Firebase
// On iOS, if GoogleService-Info.plist is present, Firebase will use it automatically
// But we still provide config for consistency
let app;
if (getApps().length === 0) {
  const platform = Capacitor.getPlatform();
  console.log('Initializing Firebase for platform:', platform);
  console.log('Using appId:', firebaseConfig.appId);
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
  console.log('Firebase already initialized, using existing app');
}

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Set Firebase Auth persistence to LOCAL (persists across app restarts)
// This is critical for iOS to maintain authentication state when app is closed
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase Auth persistence set to LOCAL - auth will persist across app restarts');
  })
  .catch((error) => {
    console.error('Failed to set Firebase Auth persistence:', error);
  });

export default app;
